export default __webpack_public_path__ + "assets/ic-list-expanded.svg";